import { Injectable } from '@angular/core';
import { DocumentModel } from '../../model/DocumentModel';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ListeDocumentsService{
    constructor(private http: HttpClient){}
    hp = new HttpParams();

    recupListeDocuments(idMouvement: string, noLigne: number, loginUser: string): Observable<DocumentModel[]>{
        if (idMouvement != null) { this.hp = this.hp.set('idMouvement', idMouvement); }
        if (noLigne != null) { this.hp = this.hp.set('noLigne', noLigne.toString()); }
        if (noLigne != null) { this.hp = this.hp.set('loginUser', loginUser); }

        const params = {params: this.hp};
        return this.http.get<DocumentModel[]>("api/services/datamatrix/liste-docs", params);
    }

    recupListeMouvement(): Observable<string[]>{
        return this.http.get<string[]>("api/services/datamatrix/liste-mouvements");
    }

    recupListeLignesCap(idMouvement: string): Observable<string[]>{
        if (idMouvement != null) { this.hp = this.hp.set('idMouvement', idMouvement); }
        const params = {params: this.hp};
        return this.http.get<string[]>("api/services/datamatrix/liste-lignes-cap");
    }
}